const management = {
	alert: {
		shutdown:
			"Afsluiten van een VPS kort na het opstarten kan langer duren dan normaal of niet succesvol uitgevoerd worden. Als u het afsluiten opnieuw wil proberen, klik dan nogmaals op 'Shutdown' totdat de actie succesvol is uitgevoerd.",
	},
	config: {
		delete: "VPS opzeggen",
		title: "VPS configuratie",
		update: "VPS bewerken",
	},
	general: {
		console: "Open console",
		day: "dag",
		days: "dagen",
		description: "Omschrijving",
		description_updated: "Uw VPS omschrijving is succesvol gewijzigd.",
		hostname: "Hostnaam",
		name: "Naam",
		relation: "Relatie",
		title: "VPS-informatie",
		uptime: "Uptime",
	},
	notifications: {
		pending: "Er staan wijzigingen klaar die pas toegepast worden na het rebooten van uw machine.",
		update: "De wijzigingen voor VPS <strong>{{name}}</strong> worden verwerkt...",
		update_active:
			"Op dit moment is de VPS-configuratie aan het updaten. Voordat u wijzigingen aanbrengt, is het noodzakelijk om uw VPS opnieuw op te starten.",
	},
	pending_dialog: {
		description:
			"Hieronder bevinden zich de wijzigingen die pas toegepast kunnen worden na het rebooten van uw machine.",
		reboot_button: "Rebooten",
		title: "Wijzigingen in afwachting",
	},
	snapshots: {
		available: "beschikbaar",
		create: "Snapshot maken",
		description: "Snapshot informatie",
		dialog_create: {
			description: "Een nieuwe snapshot toevoegen.",
			expiring_date_first: "Snapshot opruimen na",
			expiring_date_second: "dagen.",
			name_fail: "De naam voldoet niet aan de voorwaarden.",
			title: "Snapshot toevoegen",
		},
		dialog_delete: {
			description:
				"Weet u zeker dat u snapshot <strong>{{name}}</strong> definitief wilt verwijderen?",
			title: "Snapshot verwijderen",
		},
		dialog_rollback: {
			description:
				"De VPS met alle data  wordt overschreven door snapshot <strong>{{name}}</strong>.",
			extra_options: {
				alert:
					"Het aantal snapshots dat beschikbaar is, zal met één worden verhoogd wanneer u de bovenstaande keuze selecteert.",
				option_one: "Maak vooraf van de huidige status een snapshot.",
				title: "Extra opties",
			},
			title: "Snapshot herstellen",
		},
		from: "van ",
		last_made: "Laatst gemaakte snapshot",
		not_available_button: "Geen snapshots beschikbaar. Klik hier om snapshots in te stellen",
		not_found: "Geen snapshots gevonden.",
		title: "Snapshots",
	},
	ssh: {
		description:
			"Hier bevinden zich de SSH keys die tijdens het aanmaken van de VPS gekoppeld zijn aan deze VPS. Dit is niet realtime.",
		expired: {
			description:
				"De SSH-keys worden tot 31 dagen na het aanmaken van een VPS getoond. Na het verstrijken van deze periode worden, zijn ze alleen nog direct bij de VPS op te vragen, om desinformatie tegen te gaan.",
			title: "De SSH-keys worden hier niet meer getoond.",
		},
		not_found: "Geen SSH-keys gevonden.",
	},
	title: "VPS-informatie",
};

export default management;
